exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contract-name[data-v-17dc534e]{line-height:30px;overflow:hidden}.contract-name>span[data-v-17dc534e]{max-width:100%;display:inline-block;padding:3px 0;line-height:1;vertical-align:middle;cursor:pointer;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;overflow-y:hidden;color:#290202;font-weight:800;font-size:16px}.contract-name>span[data-v-17dc534e]:hover{border-bottom:1px solid #ec1c1c;color:#ec1c1c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17dc534e","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/apply-list/corpContractName.vue
// module id = YpG1
// module chunks = 23 24 27 31 41 42 50 103